import { Modal, Divider, message, Select, Input } from 'antd';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';

import CustomButton from '../CustomButton';
import FormInput from '../FormInput';
import Loading from '../Loading';

import { Pour } from '../../common/Variable';
import { airtableURL } from '../../FetchURL';
import http from '../../http-common';

import './index.scss';

const { TextArea } = Input;
const EditEntryModal = (props) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      entryName: props.name,
      entryCategory: { label: props.entryCategory, value: props.entryCategoryValue },
      entryPour: props.entryPour,
      entryBio: props.entryBio,
    },
    onSubmit: async (values) => {
      formik.setSubmitting(false);
      setLoading(true);

      try {
        await http.post(airtableURL + '/update-entry', {
          entryID: props.record,
          entryName: values.entryName,
          entryCategory: values.entryCategory.value,
          entryPour: values.entryPour,
          entryBio: values.entryBio,
        });

        const data = {
          description: values.entryBio,
          fullCategory: values.entryCategory.label,
          fullCategoryValue: values.entryCategory.value,
          id: props.record,
          name: values.entryName,
          pour: values.entryPour,
          boty: props.entryBoty,
        };

        props.handleCancel();
        setLoading(false);
        props.updateShoppingData(data.id, data);
        values.entryCategory = values.entryCategory.label;
        props.setEntryValues(values);
        message.success('Update Success');
      } catch (error) {
        setLoading(false);
        message.error(error.response.data ? error.response.data.error : 'Update Entry Error! Please try again');
        // setErrorMessage("Authentication Failed! Please try again");
      }
    },
    validationSchema: Yup.object().shape({
      entryName: Yup.string().required('Required'),
      entryCategory: Yup.object().required('Required'),
      entryPour: Yup.string().required('Required'),
    }),
  });

  return (
    <>
      <Modal
        title="Edit Entry"
        open={props.isModalOpen}
        onOk={props.handleOk}
        onCancel={props.handleCancel}
        className="edit-entry-modal"
        footer={[
          <CustomButton primary="" onClick={props.handleCancel} label="Cancel" key="key" />,
          <CustomButton primary="primary" onClick={formik.handleSubmit} loading={loading} label="Save" key="submit" />,
        ]}
      >
        <Divider />

        {loading ? (
          <div style={{ height: '300px' }}>
            <Loading />
          </div>
        ) : (
          <>
            <div className="d-flex">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="customize-svg"
              >
                <path
                  d="M15 4.5H13.5V3C13.5 2.80109 13.421 2.61032 13.2803 2.46967C13.1397 2.32902 12.9489 2.25 12.75 2.25H2.25C2.05109 2.25 1.86032 2.32902 1.71967 2.46967C1.57902 2.61032 1.5 2.80109 1.5 3V14.25C1.5 15.4905 2.5095 16.5 3.75 16.5H11.25C12.4905 16.5 13.5 15.4905 13.5 14.25V13.5H15C15.8273 13.5 16.5 12.8273 16.5 12V6C16.5 5.17275 15.8273 4.5 15 4.5ZM12 14.25C12 14.6632 11.664 15 11.25 15H3.75C3.336 15 3 14.6632 3 14.25V3.75H12V14.25ZM15 12H13.5V6H15V12Z"
                  fill="#595959"
                />
                <path d="M4.5 5.25H6V12.75H4.5V5.25ZM9 5.25H10.5V12.75H9V5.25Z" fill="#595959" />
              </svg>

              <FormInput
                id="entryName"
                name="entryName"
                onChange={formik.handleChange('entryName')}
                value={formik.values.entryName}
                placeHolder="Name"
              />
              {formik.errors.entryName && formik.touched.entryName && (
                <div className="custom__input-error">{formik.errors.entryName}</div>
              )}
            </div>
            <div className="d-flex">
              <svg
                width="16"
                height="12"
                viewBox="0 0 16 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="customize-svg"
              >
                <path
                  d="M15.0312 0.375H4.76562C4.68828 0.375 4.625 0.438281 4.625 0.515625V1.5C4.625 1.57734 4.68828 1.64062 4.76562 1.64062H15.0312C15.1086 1.64062 15.1719 1.57734 15.1719 1.5V0.515625C15.1719 0.438281 15.1086 0.375 15.0312 0.375ZM15.0312 5.36719H4.76562C4.68828 5.36719 4.625 5.43047 4.625 5.50781V6.49219C4.625 6.56953 4.68828 6.63281 4.76562 6.63281H15.0312C15.1086 6.63281 15.1719 6.56953 15.1719 6.49219V5.50781C15.1719 5.43047 15.1086 5.36719 15.0312 5.36719ZM15.0312 10.3594H4.76562C4.68828 10.3594 4.625 10.4227 4.625 10.5V11.4844C4.625 11.5617 4.68828 11.625 4.76562 11.625H15.0312C15.1086 11.625 15.1719 11.5617 15.1719 11.4844V10.5C15.1719 10.4227 15.1086 10.3594 15.0312 10.3594ZM0.828125 1.00781C0.828125 1.13708 0.853587 1.26509 0.903056 1.38452C0.952526 1.50395 1.02503 1.61246 1.11644 1.70387C1.20785 1.79528 1.31637 1.86779 1.4358 1.91726C1.55523 1.96673 1.68323 1.99219 1.8125 1.99219C1.94177 1.99219 2.06977 1.96673 2.1892 1.91726C2.30863 1.86779 2.41715 1.79528 2.50856 1.70387C2.59997 1.61246 2.67247 1.50395 2.72194 1.38452C2.77141 1.26509 2.79688 1.13708 2.79688 1.00781C2.79688 0.878543 2.77141 0.750538 2.72194 0.631109C2.67247 0.511679 2.59997 0.403162 2.50856 0.311754C2.41715 0.220347 2.30863 0.147838 2.1892 0.0983685C2.06977 0.048899 1.94177 0.0234375 1.8125 0.0234375C1.68323 0.0234375 1.55523 0.048899 1.4358 0.0983685C1.31637 0.147838 1.20785 0.220347 1.11644 0.311754C1.02503 0.403162 0.952526 0.511679 0.903056 0.631109C0.853587 0.750538 0.828125 0.878543 0.828125 1.00781ZM0.828125 6C0.828125 6.12927 0.853587 6.25727 0.903056 6.3767C0.952526 6.49613 1.02503 6.60465 1.11644 6.69606C1.20785 6.78747 1.31637 6.85997 1.4358 6.90944C1.55523 6.95891 1.68323 6.98438 1.8125 6.98438C1.94177 6.98438 2.06977 6.95891 2.1892 6.90944C2.30863 6.85997 2.41715 6.78747 2.50856 6.69606C2.59997 6.60465 2.67247 6.49613 2.72194 6.3767C2.77141 6.25727 2.79688 6.12927 2.79688 6C2.79688 5.87073 2.77141 5.74273 2.72194 5.6233C2.67247 5.50387 2.59997 5.39535 2.50856 5.30394C2.41715 5.21253 2.30863 5.14003 2.1892 5.09056C2.06977 5.04109 1.94177 5.01562 1.8125 5.01562C1.68323 5.01562 1.55523 5.04109 1.4358 5.09056C1.31637 5.14003 1.20785 5.21253 1.11644 5.30394C1.02503 5.39535 0.952526 5.50387 0.903056 5.6233C0.853587 5.74273 0.828125 5.87073 0.828125 6ZM0.828125 10.9922C0.828125 11.1215 0.853587 11.2495 0.903056 11.3689C0.952526 11.4883 1.02503 11.5968 1.11644 11.6882C1.20785 11.7797 1.31637 11.8522 1.4358 11.9016C1.55523 11.9511 1.68323 11.9766 1.8125 11.9766C1.94177 11.9766 2.06977 11.9511 2.1892 11.9016C2.30863 11.8522 2.41715 11.7797 2.50856 11.6882C2.59997 11.5968 2.67247 11.4883 2.72194 11.3689C2.77141 11.2495 2.79688 11.1215 2.79688 10.9922C2.79688 10.8629 2.77141 10.7349 2.72194 10.6155C2.67247 10.4961 2.59997 10.3875 2.50856 10.2961C2.41715 10.2047 2.30863 10.1322 2.1892 10.0827C2.06977 10.0333 1.94177 10.0078 1.8125 10.0078C1.68323 10.0078 1.55523 10.0333 1.4358 10.0827C1.31637 10.1322 1.20785 10.2047 1.11644 10.2961C1.02503 10.3875 0.952526 10.4961 0.903056 10.6155C0.853587 10.7349 0.828125 10.8629 0.828125 10.9922Z"
                  fill="#595959"
                />
              </svg>
              <Select
                id="entryCategory"
                name="entryCategory"
                onChange={(value, option) => {
                  formik.setFieldValue('entryCategory', option);
                }}
                value={formik.values.entryCategory}
                options={props.categories}
                className="w-100"
              />
              {formik.errors.entryCategory && formik.touched.entryCategory && (
                <div className="custom__input-error">{formik.errors.entryCategory}</div>
              )}
            </div>
            <div style={{ marginBottom: '14px' }}></div>
            <div className="d-flex">
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="customize-svg"
              >
                <path
                  d="M7.98945 0.17945C4.10645 0.184723 0.96875 3.32593 0.96875 7.20894C0.96875 9.45894 2.02695 11.4628 3.67227 12.7496L3.01309 13.5933C2.94102 13.6865 3.00781 13.8218 3.12383 13.8201L6.05938 13.806C6.15078 13.806 6.21758 13.7199 6.19473 13.632L5.50039 10.7791C5.49412 10.7533 5.48072 10.7299 5.46173 10.7115C5.44274 10.693 5.41892 10.6803 5.39303 10.6748C5.36714 10.6693 5.34022 10.6712 5.31537 10.6803C5.29051 10.6894 5.26874 10.7054 5.25254 10.7263L4.53711 11.6421C4.35781 11.5015 4.18555 11.3486 4.02207 11.1851C3.50812 10.6729 3.09858 10.0658 2.81621 9.39742C2.52266 8.70484 2.375 7.96832 2.375 7.20894C2.375 6.44957 2.52266 5.71304 2.81621 5.02047C3.09922 4.35074 3.50527 3.74957 4.02207 3.23277C4.53887 2.71597 5.14004 2.30992 5.80977 2.02691C6.5041 1.73336 7.24062 1.5857 8 1.5857C8.75938 1.5857 9.4959 1.73336 10.1885 2.02691C10.8582 2.30992 11.4594 2.71597 11.9762 3.23277C12.493 3.74957 12.899 4.35074 13.182 5.02047C13.4756 5.71304 13.6232 6.44957 13.6232 7.20894C13.6232 7.96832 13.4756 8.70484 13.182 9.39742C12.8997 10.0658 12.4901 10.6729 11.9762 11.1851C11.8443 11.3169 11.7072 11.44 11.5648 11.5578C11.5363 11.5809 11.5181 11.6144 11.5141 11.651C11.5102 11.6875 11.5208 11.7242 11.5437 11.7529L12.2363 12.6406C12.2855 12.7021 12.3752 12.7127 12.4367 12.6634C14.0205 11.3732 15.0312 9.40972 15.0312 7.20894C15.0312 3.32242 11.8777 0.174177 7.98945 0.17945Z"
                  fill="#595959"
                />
              </svg>
            </div>
            <Select
              id="entryPour"
              name="entryPour"
              onChange={(value) => {
                formik.setFieldValue('entryPour', value);
              }}
              value={formik.values.entryPour}
              options={Pour}
              className="w-100"
            />
            {formik.errors.entryPour && formik.touched.entryPour && (
              <div className="custom__input-error">{formik.errors.entryPour}</div>
            )}
            <div style={{ marginBottom: '14px' }}></div>
            <TextArea
              name="entryBio"
              id="entryBio"
              onChange={formik.handleChange('entryBio')}
              value={formik.values.entryBio}
              rows={6}
              className="text-area"
              placeholder="Entry Short Bio & Additional Information (Optional)"
            />
          </>
        )}
        <Divider />
      </Modal>
    </>
  );
};

export default EditEntryModal;
